import {ChurchAddressBook} from '../../tenant/church-address-book';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/account/auth.service';
import { GlobalService } from '../services/global.service';
import { IdentityService } from '../services/identity.service';
import { ViewportScroller } from '@angular/common';
import { LoaderLogoCacheService } from '../services/loader-logo-cache.service';
import { LoadingRecoveryService } from './loading-recovery.service';
import { LoadingWatchdog } from './loading-watchdog';
import { LoaderPosition } from './loader-position';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit, AfterViewInit, OnDestroy {
  private position?: LoaderPosition;
  failed = false;
  timedOut = false;
  private watchdog = new LoadingWatchdog();
  private timer: ReturnType<typeof setInterval>;
  private unregister: () => void;
  DontShow: boolean = true;
  logoSource: string = '';
  private logoTenant: string = '';
  constructor(public globalService: GlobalService, private identityService: IdentityService, private _router: Router,private authService: AuthService,
    private viewportScroller: ViewportScroller,
    private logoCache: LoaderLogoCacheService,
    private recovery: LoadingRecoveryService,
    private element: ElementRef<HTMLElement>,
    private zone: NgZone,
    private changeDetector: ChangeDetectorRef,
    private addresses: ChurchAddressBook = null
  ) {}

  ngOnInit(): void {
    // this.viewportScroller.scrollToPosition([0, 0]);
    this.DontShow = false;
    this.unregister = this.recovery.register(() => this.fail(false));
    // One lightweight check per second, outside Angular change detection.
    this.zone.runOutsideAngular(() => {
      this.timer = setInterval(() => {
        const visible = this.visible();
        if (!visible) {
          this.watchdog.tick(false, performance.now());
          if (this.failed) this.zone.run(() => { this.failed = false; this.changeDetector.markForCheck(); });
        } else if (!this.failed && this.watchdog.tick(true, performance.now())) this.fail(true);
      }, 1000);
    });
    void this.loadChurchLogo();
    // this.viewportScroller.scrollToPosition([0, 0]);
  } 

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      this.position = new LoaderPosition(this.element.nativeElement);
      this.position.start();
    });
  }

  onLogoError(): void {
    this.logoSource = '';
    if (this.logoTenant) this.logoCache.invalidate(this.logoTenant);
  }

  private visible(): boolean {
    const element = this.element.nativeElement;
    return element.isConnected && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  }

  private fail(timedOut: boolean): boolean {
    if (!this.visible()) return false;
    if (this.failed) return true;
    this.zone.run(() => {
      this.failed = true;
      this.timedOut = timedOut;
      this.changeDetector.markForCheck();
    });
    return true;
  }

  reload(): void { window.location.reload(); }

  ngOnDestroy(): void {
    this.position?.stop();
    clearInterval(this.timer);
    this.unregister?.();
  }

  private async loadChurchLogo(): Promise<void> {
    const tenant = this.getLoaderTenant();
    this.logoTenant = tenant;
    this.logoSource = this.logoCache.getCached(tenant);
    const image = await this.logoCache.refresh(tenant);
    if (image) this.logoSource = image;
  }

  private getLoaderTenant(): string {
    if(this.addresses?.domain)return this.addresses.domain.subdomain;
    const pathTenant = window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase();
    const nonTenantRoutes = new Set(['home', 'login', 'signup', 'resetpassword', '404', 'admin', 'member', 'usher']);
    if (pathTenant && !nonTenantRoutes.has(pathTenant)) return pathTenant;

    try {
      const storedTenant = localStorage.getItem('tenant')?.toLowerCase();
      if (storedTenant) return storedTenant;
    } catch { }

    const host = window.location.hostname.toLowerCase();
    if (host.endsWith('.localhost')) {
      return host.slice(0, -'.localhost'.length).split('.').pop() || 'main';
    }

    const baseDomain = ['church-services.org', 'church-services-staging.org']
      .find(domain => host.endsWith(`.${domain}`));
    if (baseDomain) {
      const subdomain = host.slice(0, -(baseDomain.length + 1)).split('.').pop();
      if (subdomain && subdomain !== 'main') return subdomain;
    }

    return 'main';
  }
  
  GoHome(){ 
    this.identityService.authenticated = false;
    this.identityService.permissions = [];
    this.authService.logout(1);
    this._router.navigate([this.globalService.subdomain + '/login']);
  }   
}
           
